import * as React from "react";
import { MemoryRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../../components/Login";
import ProtectedRoute from "../../components/ProtectedRoute";
import AlphaEditPopup from "./AlphaEditPopup";
import "../../styles/globals.css";

const App: React.FC = () => {
  window.history.replaceState(null, "", window.location.pathname);
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute authenticatedElement={<AlphaEditPopup />} />} />
      </Routes>
    </Router>
  );
};

export default App;
